import React from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import {Label} from "@irati/ui/src/Typography"

import StyledIconText from "./styled/IconText"
import DealHighlightTypes from "../../constants/dealHighlightTypes"

const getText = (type) => {
  switch (type) {
    case DealHighlightTypes.COUPON:
    case DealHighlightTypes.DIGITAL:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.digital" />
    case DealHighlightTypes.PHYSICAL:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.physical" />
    case DealHighlightTypes.INSTANT:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.instant" />
    case DealHighlightTypes.ONE_HOUR:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.1hr" />
    case DealHighlightTypes.COMPANY_BENEFIT:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.company" />
    case DealHighlightTypes.APP_ONLY:
      return <FormattedMessage id="perks.dealHighlight.dealHighlightRow.appOnly" />
    case DealHighlightTypes.TIME_LIMIT_24_HOUR:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.timeLimit24Hours" />
    default:
      return <span />
  }
}

// GOLDEN
const DealHighlightRow = (props) => {
  const {type, size, isLabel} = props

  if (!type) {
    return null
  }

  const idNamespace = id("deal-highlight-row", props)

  return (
    <StyledIconText id={idNamespace} size={size} icon={type}>
      {isLabel && <Label id={id("label", idNamespace)} color="contrast">{getText(type)}</Label>}
    </StyledIconText>
  )
}

const {oneOf, bool, number} = PropTypes

DealHighlightRow.defaultProps = {
  type: null,
  size: 16,
  isLabel: true
}

DealHighlightRow.propTypes = {
  size: number,
  type: oneOf([
    DealHighlightTypes.DIGITAL,
    DealHighlightTypes.PHYSICAL,
    DealHighlightTypes.COUPON,
    DealHighlightTypes.INSTANT,
    DealHighlightTypes.ONE_HOUR,
    DealHighlightTypes.COMPANY_BENEFIT,
    DealHighlightTypes.APP_ONLY,
    DealHighlightTypes.TIME_LIMIT_24_HOUR
  ]),
  isLabel: bool
}

export default DealHighlightRow
